import { memo } from 'react'
import ProfileAvatar from './ProfileAvatar'
import { getWebApp } from '../lib/telegram'

function CatalogHeader({ formattedBalance, onTopUp, isAdmin, onOpenAdmin }) {
  const tgUser = getWebApp().initDataUnsafe?.user ?? {}
  const photoUrl = tgUser.photo_url || ''
  const firstName = tgUser.first_name || 'Гость'
  const username = tgUser.username || ''

  return (
    <header className="mb-6">
      <div className="flex items-center justify-between gap-3">
        <ProfileAvatar photoUrl={photoUrl} name={firstName} size={36} />

        <div className="min-w-0 flex-1 text-left">
          <p className="truncate text-[14px] font-[510] leading-4 tracking-[-0.01em] text-[var(--color-text)]">
            {firstName}
          </p>
          {username ? (
            <p className="truncate text-[12px] font-[510] leading-[14px] tracking-[-0.01em] text-[var(--tma-text-secondary)]">@{username}</p>
          ) : null}
        </div>

        <button
          type="button"
          onClick={onTopUp}
          className="inline-flex shrink-0 items-center gap-2 rounded-full border border-[var(--color-border)] bg-[var(--color-card)] px-3 py-2 transition active:scale-[0.98]"
        >
          <span className="text-[16px] font-[510] leading-5 tracking-[-0.01em] text-[var(--color-text)]">
            {formattedBalance} ₽
          </span>
          <span className="flex h-4 w-4 items-center justify-center rounded-full bg-accent">
            <img loading="eager" src="/images/icons/figma/plus.svg" alt="" width="16" height="16" className="h-4 w-4" aria-hidden="true" />
          </span>
        </button>

        {isAdmin ? (
          <button
            type="button"
            onClick={onOpenAdmin}
            aria-label="Админка"
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-[var(--color-border)] bg-[var(--color-card)] text-[var(--color-text-secondary)] transition active:scale-95"
          >
            <img loading="eager" src="/images/icons/figma/settings.svg" alt="" width="28" height="28" className="h-7 w-7" aria-hidden="true" />
          </button>
        ) : null}
      </div>
    </header>
  )
}

export default memo(CatalogHeader)
